import { render, staticRenderFns } from "./userProfileEntityDocumentsData.vue?vue&type=template&id=50fd92ff&scoped=true"
import script from "./userProfileEntityDocumentsData.vue?vue&type=script&lang=js"
export * from "./userProfileEntityDocumentsData.vue?vue&type=script&lang=js"
import style0 from "./userProfileEntityDocumentsData.vue?vue&type=style&index=0&id=50fd92ff&prod&lang=scss&scoped=true"
import style1 from "./userProfileEntityDocumentsData.vue?vue&type=style&index=1&id=50fd92ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd92ff",
  null
  
)

export default component.exports